// @flow

import * as yup from 'yup';

import { __ } from '../../../i18n/l10n';

export const FormAddressSchema: any = () =>
  yup.object().shape({
    address1: yup
      .string()
      .required(__('Your postal address is required.'))
      .max(256, __('Your postal address cannot be over %1$s characters.', 256)),
    address2: yup.string().max(256, __('Your postal address cannot be over %1$s characters.', 256)),
    zip_code: yup
      .string()
      .required(__('Your postal code is required.'))
      .max(10, __('Your postal code cannot be over %1$s characters.', 10)),
    city: yup
      .string()
      .required(__('Your city is required.'))
      .max(50, __('Your city cannot be over %1$s characters.', 50)),
    country: yup
      .string()
      .required(__('Your country is required.'))
      .max(2, __('Your country cannot be over %1$s characters.', 2)),
  });
